<template>
  <div class="landing">
    <div class="content">
      <div class="logo">
        <img src="/images/revel-x-como.svg" />
      </div>
      <welcome @learn="goToFeatures" />
      <features ref="features" @learn="goToHowItWorks" />
      <how-it-works ref="howItWorks" />
      <div
        class="additional-charges"
      >* Additional emails/SMSes will be charged based on provider cost.</div>
    </div>
  </div>
</template>

<script>
import Welcome from "./Welcome";
import Features from "./Features";
import HowItWorks from "./HowItWorks";

export default {
  components: {
    Welcome,
    Features,
    HowItWorks
  },
  created() {
    this.$ga.page("Landing Page");
  },
  methods: {
    goToFeatures() {
      this.goTo(this.$refs.features);
    },
    goToHowItWorks() {
      this.goTo(this.$refs.howItWorks);
    },
    goTo(ref) {
      this.$vuetify.goTo(ref, { offset: 50 });
    }
  }
};
</script>

<style lang="scss" scoped>
.landing {
  background-image: url("/images/background.svg");
  background-position: calc(50% + 140px) -400px;
  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-width: 1200px;
    max-width: 1400px;
    margin: 0 auto;
    padding: 60px;
    padding-bottom: 20px;

    > * {
      width: 100%;
    }

    > *:not(:nth-child(-n + 2)) {
      margin-top: 200px;
    }

    > .logo {
      margin-left: -60px;
      img {
        width: 180px;
      }
    }

    .additional-charges {
      text-align: center;
      font-size: 14px;
      font-weight: 300;
      color: #333d4d;
    }
  }

  // Mobile
  #app.mobile & {
    background-image: url("/images/background-mobile.svg");
    background-position: 60% 250px;
    .content {
      min-width: initial;
      max-width: initial;
      padding: 30px 0;
      padding-bottom: 20px;

      > *:not(:nth-child(-n + 2)) {
        margin-top: 80px;
      }

      > .logo {
        margin-top: -1px;
        margin-left: 48px;
        margin-bottom: 26px;
        img {
          width: 120px;
        }
      }
    }
  }
}
</style>